if (!customElements.get('mega-menu-hover')) {
  customElements.define(
    'mega-menu-hover',
    class MegaMenuHover extends HTMLElement {
      constructor() {
        super();
        this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
        this.closeDelay = 150;
        this.closeTimers = new Map();
        this.listeners = [];
      }

      connectedCallback() {
        this.menus = Array.from(this.querySelectorAll('header-menu'));
        this.menus.forEach((menu) => {
          const details = menu.querySelector('details');
          if (!details) return;
          const onEnter = () => this.openMenu(menu, details);
          const onLeave = () => this.scheduleClose(menu, details);
          menu.addEventListener('mouseenter', onEnter);
          menu.addEventListener('mouseleave', onLeave);
          this.listeners.push([menu, onEnter, onLeave]);
        });
      }

      disconnectedCallback() {
        this.listeners.forEach(([menu, onEnter, onLeave]) => {
          menu.removeEventListener('mouseenter', onEnter);
          menu.removeEventListener('mouseleave', onLeave);
        });
        this.listeners = [];
        this.closeTimers.forEach((timer) => clearTimeout(timer));
        this.closeTimers.clear();
      }

      openMenu(menu, details) {
        if (!this.hoverQuery.matches) return;
        clearTimeout(this.closeTimers.get(menu));

        this.menus.forEach((otherMenu) => {
          if (otherMenu === menu) return;
          const otherDetails = otherMenu.querySelector('details');
          if (otherDetails && otherDetails.open) otherMenu.close();
        });

        if (!details.open) {
          details.setAttribute('open', '');
          details.querySelector('summary').setAttribute('aria-expanded', 'true');
        }
      }

      scheduleClose(menu, details) {
        if (!this.hoverQuery.matches) return;
        clearTimeout(this.closeTimers.get(menu));
        this.closeTimers.set(
          menu,
          setTimeout(() => {
            if (details.open && !menu.contains(document.activeElement)) menu.close();
          }, this.closeDelay)
        );
      }
    }
  );
}
